import { add, differenceInCalendarDays, startOfDay } from 'date-fns';

import { timeLineDaysCount } from './epg-config';

function getTimeLineDays(timeLineStart: Date, timeLineEnd?: Date) {
    return Array.from(
        Array(
            timeLineEnd
                ? Math.abs(differenceInCalendarDays(timeLineEnd, timeLineStart))
                : timeLineDaysCount,
        ),
    ).map((_, idx) => startOfDay(add(timeLineStart, { days: idx })));
}

export default getTimeLineDays;
